export const getStringPercentageScore = (
  score: number,
  total: number
): string => {
  return ((score / total) * 100).toFixed() + "%";
};
